<template>
  <div id="dashboard" class="bg-dark">
    <div class="dashboard-search-block" v-if="!standaloneDashboard" >
      <div id="dashboard-search-content" class="search-rectangle ccike-flex-column">
        <div class="dashboard-search-element">
            <b-input-group>
              <b-input-group-prepend>
                <span class="m-magnify">
                  <font-awesome-icon :icon="['fas', 'magnifying-glass']" size="lg" style="color: #ffffff;" />
                </span>
              </b-input-group-prepend>
              <b-form-input id="dashboard-search-input" v-model="searchText" class="ccike-searchterm-input dashboard-search-input-width"
                placeholder="What data are you looking for?" v-on:keyup.enter="gotoSearch()"></b-form-input>
              <div id="dashboard-search-button" class="input-group-append">
                <b-button v-if="windowWidth > 820" squared class="ccike-search-button NotesEsa-button" @click="gotoSearch()">Search</b-button>
                <b-button v-else squared class="ccike-search-button f NotesEsa-button" @click="gotoSearch()">
                  <font-awesome-icon :icon="['fas', 'arrow-right']" style="color: #000000;"/>
                </b-button>
              </div>
            </b-input-group>
            <div id="ccike-dashboard-advanced-search-button" class="ccike-flex-center">
              <b-button squared variant="none" size="md" class="NotesEsa-button" v-on:click="gotoSearch()">
                <span class="ccike-flex btn-text-white">
                  Advanced search
                  <span style="float: right; margin-left: 10px">
                    <font-awesome-icon :icon="['fas', 'arrow-right']"/>
                  </span>
                </span>
              </b-button>
              </div>
          </div>
        <div id="ccike-dashboard-down-arrow" class="ccike-flex-center ccike-dashboard-down-arrow">
          <span class="NotesEsa-button">
            <a href="#dashboard-content"><font-awesome-icon :icon="['fas', 'arrow-down-long']" size="xl"/></a>
          </span>
        </div>
      </div>
      </div>

    <div id="dashboard-content" :class="{ 'dashboard-content-standalone': standaloneDashboard }">
      <hr class="hr-h50" />
      <div>
        <div id="ccike-dashboard-data-btn">
          <b-button squared variant="none" class="ccike-flex color-00B398" size="md">
            <span class="NotesEsa-button m-auto">DATA</span>
          </b-button>
        </div>
        <hr class="hr-h50" />
      </div>
      <div>
        <h1>The climate record</h1>
        <hr class="hr-h50" />
        <span class="lead lead-paragraph my-3">Get free and open access to all Essential Climate Variable data
          products developed by the ESA Climate Change Initiative.</span>
      </div>
      <!-- "GRAEME Don't show C3s overlay button" div style="display: none; justify-content: end;" -->
      <!-- "GRAEME Show C3s overlay button" div style="display: flex; justify-content: end;" -->
      <div style="display: flex; justify-content: end;">
        <div id="ccike-climate-record-btns">
          <b-button squared variant="none" :disabled="c3sItems.length == 0" class="NotesEsa-button NotesEsa-button-force" size="md" v-on:click="toggleOverlay()">
            <span class="ccike-flex">
              Source: C3S
              <span class="ml-1">
                <font-awesome-icon :icon="['fas', 'minus']" style="width:1em;" v-if="!c3sOverlay"/>
                <font-awesome-icon :icon="['fas', 'check']" style="width:1em;" v-else/>
              </span>
            </span>
          </b-button>
        </div>
      </div>
      <div id="ccike-timeline-visualization-container">
        <div id="ccike-timeline-visualization"></div>
      </div>
      <div id="ccike-dashboard-getdata-btn">
        <hr class="hr-h50" />
        <b-button v-if="!standaloneDashboard" id="dashboard-get-data" squared variant="none" class="ccike-flex NotesEsa-button NotesEsa-button-black" size="lg" @click="gotoSearch()">
          Get data
        </b-button>
        <a v-else :href="searchHref">
          <b-button id="dashboard-get-data" squared variant="none" class="ccike-flex NotesEsa-button NotesEsa-button-black" size="lg">
            Get data
          </b-button>
        </a>
      </div>
      <hr class="hr-bottom" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Timeline } from "../../node_modules/vis-timeline/esnext/umd/vis-timeline-graph2d.min.js";
import { DataSet } from "../../node_modules/vis-data/esnext";

var axios = require("axios");
const http = axios.create({
  withCredentials: false,
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
});

const vueName = "Dashboard";

// Need this to not be in the Vue component as if it was, 'this' would be the Vue component.
// Being here, 'this' is the actual element that was actioned on
function manageClassEventListeners(evt) {
  if (this.action[evt.type].add) {
    this.classList.add(this.action[evt.type].klass);
  } else {
    this.classList.remove(this.action[evt.type].klass);
  }
}

var g_cciItems = undefined;
var g_c3sItems = undefined;
var g_options = undefined;
var g_groups = undefined;
var g_projectOptions = undefined;
var g_projectItems = undefined;
var g_projectGroups = undefined;
var g_cciProjectsJson = undefined;

export default {
  name: vueName,
  beforeDestroy: function () {
    this.cleanupHandler();
    console.log(vueName + " cleanup");
  },
  props: {
    c3sOverlayActive: Boolean,
  },
  data() {
    var vm = this;

    return {
      /* These are referred to via 'this'.
       */
      c3sItems: [],
      items: [],
      groups: [],
      inView: false,
      dbVerticalScroll: false,
      c3sOverlay: vm.c3sOverlayActive,
      timeline: undefined,
      dashboardHoverGroup: null,
      searchText: "",
      standaloneDashboard: false,
      searchHref: undefined,
      windowWidth: 0
    };
  },
  created() {
    var vm = this;

    vm.windowWidth = window.innerWidth;
    function updateWindoWidth() {
      vm.windowWidth = window.innerWidth;
    }

    window.onresize = updateWindoWidth;

    let currentRoutes = vm.$router.getRoutes().filter(function (route) {
      return route.name === 'Search';
    });
    vm.standaloneDashboard = (currentRoutes.length == 0);

    this.inView = true;
    console.log(vueName + " created");
  },
  async mounted() {
    /* Refer to the vue instance as 'vm'
     */
    var vm = this;

    if (vm.standaloneDashboard) {
      // Standalone dashboard used to go here. Ed requested it just goes to the proper ODP Dashboard.
      // vm.searchHref = window.location.pathname + '/data/#/search';
      vm.searchHref = window.location.pathname + '/data';
      vm.searchHref = vm.searchHref.replace('//', '/')
    }

    var tlReady = true;
    if (
      g_cciItems === undefined ||
      g_c3sItems === undefined ||
      g_groups === undefined ||
      g_options === undefined ||
      g_projectItems === undefined ||
      g_projectGroups === undefined ||
      g_projectOptions === undefined ||
      g_cciProjectsJson === undefined
    ) {
      g_options = {};
      g_groups = [];
      g_cciItems = [];
      g_c3sItems = [];
      g_projectOptions = {};
      g_projectItems = {};
      g_projectGroups = {};
      tlReady = await this.prepareTimelineVars();
    }
    if (tlReady) {
      vm.c3sItems = g_c3sItems;
      if (vm.c3sOverlay) {
        vm.items = new DataSet(g_c3sItems.concat(g_cciItems));
      } else {
        vm.items = new DataSet(g_cciItems);
      }
      vm.groups = new DataSet(g_groups);
      vm.cciProjectsJson = g_cciProjectsJson;

      // Create a Timeline
      vm.timeline = new Timeline(
        document.getElementById("ccike-timeline-visualization")
      );
      vm.timeline.setOptions(g_options);
      vm.timeline.setGroups(vm.groups);
      vm.timeline.setItems(vm.items);

      // Setup the event listeners required
      vm.timeline.on("click", function (properties) {
        vm.clickHandler(properties);
      });

      const timelineContainer = document.getElementById("ccike-timeline-visualization");
      timelineContainer.addEventListener("mouseleave", (e) => {
        let properties = { group: null };
        vm.manageTimelineEvents(properties);
      });

      vm.timeline.on('mouseOver', vm.manageTimelineEvents);
    }
    
    console.log(vueName + " mounted");
  },
  methods: {
    manageTimelineEvents(properties) {
      var vm = this;

      if (properties.group) {
        // We have a valid group
        if (properties.group !== vm.dashboardHoverGroup) {
          if (vm.dashboardHoverGroup) {
            // And its not the same valid group as previously
            //
            // Remove the previously injected classes
            let classes = vm.dashboardHoverGroup + " vis-group";
            let collection = document.getElementsByClassName(classes);
            for (let i = 0; i < collection.length; i++) {
              if (collection[i].classList.contains("dashboard-hover")) {
                collection[i].classList.remove("dashboard-hover");
              }
            }

            classes = vm.dashboardHoverGroup + " vis-item";
            collection = document.getElementsByClassName(classes);
            for (let i = 0; i < collection.length; i++) {
              let content = collection[i].getElementsByClassName('vis-item-content');
              if (content && content.length > 0) {
                content[0].classList.remove("ccike-show");
              }
            }

            classes = vm.dashboardHoverGroup + " vis-label";
            collection = document.getElementsByClassName(classes);
            for (let i = 0; i < collection.length; i++) {
              if (collection[i].classList.contains("dashboard-hover")) {
                collection[i].classList.remove("dashboard-hover");
              }
            }
          }
        }

        // Add hover class over group
        let classes = properties.group + " vis-group";
        let collection = document.getElementsByClassName(classes);
        for (let i = 0; i < collection.length; i++) {
          collection[i].classList.add("dashboard-hover");
        }

        // Show the content of item in group
        classes = properties.group + " vis-item";
        collection = document.getElementsByClassName(classes);
        for (let i = 0; i < collection.length; i++) {
          let content = collection[i].getElementsByClassName('vis-item-content');
          if (content && content.length > 0) {
            content[0].classList.add("ccike-show");
          }
        }

        // Add hover class over group label
        classes = properties.group + " vis-label";
        collection = document.getElementsByClassName(classes);
        for (let i = 0; i < collection.length; i++) {
          collection[i].classList.add("dashboard-hover");
        }
      } else {
        // Remove the previously injected class on group
        if (vm.dashboardHoverGroup) {
          let classes = vm.dashboardHoverGroup + " vis-group";
          let collection = document.getElementsByClassName(classes);
          for (let i = 0; i < collection.length; i++) {
            if (collection[i].classList.contains("dashboard-hover")) {
              collection[i].classList.remove("dashboard-hover");
            }
          }

          // Remove the previously injected class on group label
          classes = vm.dashboardHoverGroup + " vis-label";
          collection = document.getElementsByClassName(classes);
          for (let i = 0; i < collection.length; i++) {
            if (collection[i].classList.contains("dashboard-hover")) {
              collection[i].classList.remove("dashboard-hover");
            }
          }

          // Show the content of item in group
          classes = vm.dashboardHoverGroup + " vis-item";
          collection = document.getElementsByClassName(classes);
          for (let i = 0; i < collection.length; i++) {
            let content = collection[i].getElementsByClassName('vis-item-content');
            if (content && content.length > 0) {
              content[0].classList.remove("ccike-show");
            }
          }
        }
      }

      vm.dashboardHoverGroup = properties.group;
    },
    toggleOverlay() {
      var vm = this;

      vm.c3sOverlay = !vm.c3sOverlay;

      if (vm.c3sOverlay) {
        vm.items = new DataSet(g_c3sItems.concat(g_cciItems));
      } else {
        vm.items = new DataSet(g_cciItems);
      }

      vm.timeline.setItems(vm.items);
    },
    doNothing(evt) {
      // Prevent default behaviour
      evt.preventDefault();
    },
    cleanupHandler() {
      this.inView = false;
      this.removeEventHandlers();
    },
    gotoSearch(selectedECV) {
      var vm = this;
      if (vm.standaloneDashboard) {
        let query = selectedECV && selectedECV.length > 0 ? '?ecv=' + selectedECV : '';
        let searchHref = window.location.pathname + '/data/#/search' + query;
        searchHref = searchHref.replace('//', '/')

        window.location.href = searchHref
      } else {
        let query = selectedECV && selectedECV.length > 0 ? '?ecv=' + selectedECV : '';
        let searchHref = window.location.pathname + '/data/#/search' + query;
        searchHref = searchHref.replace('//', '/')

        this.$router.push({
          name: "Search",
          params: {
            cciEcvConfig: vm.cciProjectsJson,
            selectedECV: selectedECV,
            c3sOverlay: vm.c3sOverlay,
            userInputText: vm.searchText,
          },
        });
      }
    },
    manageClasses(elem, klass, add) {
      var theElem = document.getElementById(elem);
      if (add) {
        theElem.classList.add(klass);
      } else {
        theElem.classList.remove(klass);
      }
    },
    clickHandler(properties) {
      var vm = this;

      if (properties.what === "group-label" || properties.what === "item") {
        this.manageClasses(
          "ccike-timeline-visualization",
          "ccike-timeline-border",
          false
        );
        var slug = undefined;
        var config = undefined;
        var groups = undefined;
        var items = undefined;
        var options = undefined;
        var selectedECV = undefined;
        var allKeys = Object.keys(vm.cciProjectsJson);
        var keys = allKeys.filter(function (elem) {
          return elem !== "facet_config" && elem !== "ecv_labels" && elem !== "full_search_results" && elem !== "ecv_title_ids";
        });
        keys.forEach(function (key, index) {
          if (vm.cciProjectsJson[key].ecv.groupId === properties.group) {
            selectedECV = vm.cciProjectsJson[key].ecv.opensearch;
            slug = vm.cciProjectsJson[key].ecv.slug;
            var myObject = {};
            myObject[key] = vm.cciProjectsJson[key];
            config = myObject;
            groups = g_projectGroups[key];
            items = g_projectItems[key];
            options = g_projectOptions[key];
          }
        });
        if (config) {
          // This takes you to the Search interface
          vm.gotoSearch(selectedECV);
        }
      }
    },
    removeEventHandlers() {
      var vm = this;

      window.removeEventListener("resize", this.updateTimelineHeight, false);
    },
    addEventHandlers() {
      var vm = this;

      // GTS this.manageClasses('app', 'ccike-background-black', true)
      vm.manageClasses(
        "ccike-timeline-visualization",
        "ccike-timeline-border",
        true
      );

      // Hook to update the timeline height if user changes window siz of brouser
      window.addEventListener(
        "resize",
        vm.updategroupIdoptionsTimelineHeight,
        false
      );

      setTimeout(function () {
        // Call this function to make sure scroller is in correct position, if
        // timeline has a vertical scroller
        vm.updateTimelineHeight();
      }, 0);
    },

    updateTimelineHeight() {
      var vm = this;

      if (vm.dbVerticalScroll) {
        setTimeout(function () {
          // This ensures that the scrolller is initially at the top
          var scroller = document.querySelector(".vis-vertical-scroll");
          if (scroller !== null && scroller.scrollTop !== undefined) {
            scroller.scrollTop = 0;
          }
        }, 0);
      }
    },

    getDateString(theDate) {
      var result =
        theDate.getFullYear() +
        "-" +
        ("0" + (theDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + theDate.getDate()).slice(-2);
      return result;
    },

    async getECVConfig() {
      var _url = "/odpui/utils/config/cci_ecv_config.json";
      var result = await http
        .get(_url)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error("AXIOS GET error: ", error);
          console.error("AXIOS GET api: ", _url);
          return undefined;
        });

      return result;
    },

    async prepareTimelineVars() {
      var vm = this;
      var result = false;
      g_cciProjectsJson = await vm.getECVConfig();
      if (g_cciProjectsJson) {
        // Do nothing
      } else {
        g_cciProjectsJson = require(process.env.CONFIG_PATH +
          "cci_ecv_config.json");
        console.log("HTTP we have an error, go for built in version of config");
      }

      vm.cciProjectsJson = g_cciProjectsJson;

      var itemId = 0;
      var minStartDate = undefined;
      var maxEndDate = undefined;
      var allKeys = Object.keys(g_cciProjectsJson);
      var keys = allKeys.filter(function (elem) {
        return elem !== "facet_config" && elem !== "ecv_labels" && elem !== "full_search_results" && elem !== "ecv_title_ids";
      });
      keys.forEach(function (key, index) {
        var foundStartDate = false;
        var foundEndDate = false;
        var startDate = undefined;
        var endDate = undefined;
        var itemClass =
          "ccike-group-item ccike-" +
          g_cciProjectsJson[key].ecv.category.replace(/ /g, "-").toLowerCase() + " ";
        g_projectItems[key] = [];
        g_projectGroups[key] = [];
        g_projectOptions[key] = {};
        var projectItemId = 0;
        g_cciProjectsJson[key].feature_collection.forEach(function (
          item,
          index
        ) {
          var labelHtml = "ccike-group-project-label";
          var titleHtml = "<div>" + item.feature_title + "</div>";
          var groupId = projectItemId;
          item.groupId = groupId;
          var groupDef = {
            id: groupId,
            className: labelHtml,
            content: item.feature_title.substring(0, 50),
            order: groupId,
          };
          if (item.feature_title.length > 50) {
            groupDef.title = item.feature_title;
          }
          g_projectGroups[key].push(groupDef);
          g_projectItems[key].push({
            id: projectItemId,
            className: itemClass,
            group: groupId,
            start: item.start,
            end: item.end,
            title: titleHtml,
            type: "range",
            content: "",
          });
          projectItemId++;
        });
        if (projectItemId > 0) {
          var tlMin = new Date(g_cciProjectsJson[key].ecv.min_date);
          tlMin.setFullYear(tlMin.getFullYear() - 3);
          var tlMax = new Date(g_cciProjectsJson[key].ecv.max_date);
          tlMax.setFullYear(tlMax.getFullYear() + 3);
          g_projectOptions[key] = {
            // onInitialDrawComplete: undefined,
            timeAxis: { scale: "year", step: 10 },
            orientation: { axis: "top" },
            stack: true,
            maxHeight: 375,
            horizontalScroll: false,
            verticalScroll: true,
            showCurrentTime: false,
            zoomable: false,
            zoomKey: "ctrlKey",
            tooltip: { overflowMethod: "cap" },
            start: vm.getDateString(tlMin),
            end: vm.getDateString(tlMax),
            min: vm.getDateString(tlMin),
            max: vm.getDateString(tlMax),
          };
        }

        startDate = new Date(g_cciProjectsJson[key].ecv.min_date);
        endDate = new Date(g_cciProjectsJson[key].ecv.max_date);
        var options = {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
        };
        var displayRange =
          startDate.toDateString(undefined, options) +
          " - " +
          endDate.toDateString(undefined, options);
        g_cciProjectsJson[key].ecv.displayRange = displayRange;
        var titleHtml =
          "<div class='NotesEsa-H6'>" +
          g_cciProjectsJson[key].ecv.min_date +
          " - " +
          g_cciProjectsJson[key].ecv.max_date +
          "</div>";
        var groupId =
          g_cciProjectsJson[key].ecv.category +
          "-" +
          key.replace(/ /g, "-").toLowerCase();
        g_cciProjectsJson[key].ecv.groupId = groupId;

        var labelHtml = "ccike-group-label NotesEsa-H5-ecv " + groupId;
        g_groups.push({
          id: groupId,
          className: labelHtml,
          content: g_cciProjectsJson[key].ecv.label + " (" + g_cciProjectsJson[key].feature_collection.length + ")",
          order: groupId,
        });

        if (g_cciProjectsJson[key].ecv.c3s_coverage) {
          let c3sOverlayClass = "ccike-group-item ccike-c3s ";
          let c3sOverlayStartDate = new Date(
            g_cciProjectsJson[key].ecv.c3s_coverage.min_date
          );
          let c3sOverlayEndDate = new Date(
            g_cciProjectsJson[key].ecv.c3s_coverage.max_date
          );
          let c3sOverlayTitleHtml =
            "<div>" +
            g_cciProjectsJson[key].ecv.c3s_coverage.min_date +
            " - " +
            g_cciProjectsJson[key].ecv.c3s_coverage.max_date +
            "</div>";
          let newItem = {
            id: itemId,
            className: c3sOverlayClass + groupId,
            group: groupId,
            start: vm.getDateString(c3sOverlayStartDate),
            end: vm.getDateString(c3sOverlayEndDate),
            title: "",
            type: "range",
            content: "",
          };
          g_c3sItems.push(newItem);
          itemId++;
        }

        g_cciItems.push({
          id: itemId,
          className: itemClass + groupId,
          group: groupId,
          start: vm.getDateString(startDate),
          end: vm.getDateString(endDate),
          title: "",
          type: "range",
          content: titleHtml,
        });
        itemId++;

        if (minStartDate === undefined) {
          minStartDate = new Date(startDate.toString());
        } else {
          if (startDate.valueOf() < minStartDate.valueOf()) {
            minStartDate = new Date(startDate.toString());
          }
        }
        if (maxEndDate === undefined) {
          maxEndDate = new Date(endDate.toString());
        } else {
          if (endDate.valueOf() > maxEndDate.valueOf()) {
            maxEndDate = new Date(endDate.toString());
          }
        }
      });
      if (itemId > 0) {
        var tlMin = new Date(minStartDate.toString());
        tlMin.setFullYear(minStartDate.getFullYear() -  3);
        var tlMax = new Date(maxEndDate.toString());
        tlMax.setFullYear(maxEndDate.getFullYear() + 2);
        g_options = {
          onInitialDrawComplete: vm.addEventHandlers,
          timeAxis: { scale: "year", step: 10 },
          orientation: { axis: "top" },
          stack: false,
          horizontalScroll: true,
          verticalScroll: true,
          showCurrentTime: false,
          zoomable: false,
          zoomKey: "ctrlKey",
          start: vm.getDateString(tlMin),
          end: vm.getDateString(tlMax),
          min: vm.getDateString(tlMin),
          max: vm.getDateString(tlMax),
        };
        result = true;
      }

      return result;
    },
  },
};
</script>

<style>
.vertical-centered {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

#dashboard .vis-item-content {
/* H6 */
display: flex;
justify-content: center;
padding: 3px 5px 5px 5px;
font-family: NotesEsabold, sans-serif;
font-style: normal;
font-weight: 700;
font-size: 1.8rem;
line-height: 27px;
color: #ffffff;
text-transform: none;
letter-spacing: normal;
visibility: hidden;
}

#dashboard .ccike-group-item {
  height: 30px !important;
  top: 8px !important;
}

#dashboard .vis-item.vis-range {
  border-radius: unset;
  border-style: unset;
  box-sizing: unset;
  font-size: 20px;
}

#dashboard .vis-labelset .vis-label .vis-inner {
  padding: unset;
  margin: auto 0;
}

#dashboard .vis-panel.vis-center, .vis-panel.vis-left, .vis-panel.vis-right {
  border-bottom-style: unset;
  border-top-style: unset;
  overflow: unset;
}

#dashboard .vis-time-axis.vis-foreground {
    opacity: 1.0;
}

#dashboard .vis-time-axis.vis-background {
    opacity: 0.3;
}

#dashboard .vis-time-axis .vis-grid.vis-vertical {
    border-left: 2px solid #ffffff;
    position: absolute;
}

#dashboard  .vis-time-axis.vis-text {
    opacity: 1;
}

#app #dashboard .vis-panel.vis-bottom,
.vis-panel.vis-top,
.vis-panel.vis-center,
.vis-panel.vis-left,
.vis-panel.vis-right {
  border-left: none;
  border-right: none;
  top: 5px !important;
}

#app #dashboard .vis-content {
  transform: unset !important;
  top: 53px !important;
}

.vis-label .vis-inner {
  min-height: 25px;
  position: relative;
}

#app .color-00B398 {
  background-color: #00B398 !important;
}

#ccike-dashboard-down-arrow .fa-xl {
  height: 30px;
  width: unset !important;
  opacity: 0.8;
}

#ccike-dashboard-down-arrow.ccike-dashboard-down-arrow {
  margin-top: auto;
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
}


</style>
